import React from "react";
import axios from 'axios';
import jwt_decode from "jwt-decode";
import dayjs from 'dayjs'

let accessToken = localStorage.getItem('accessToken') ? JSON.parse(localStorage.getItem('accessToken')) : null
let refreshToken = localStorage.getItem('refreshToken') ? JSON.parse(localStorage.getItem('refreshToken')) : null
let zohoAccessToken = localStorage.getItem('zohoAccessToken') ? JSON.parse(localStorage.getItem('zohoAccessToken')) : null
let zohoTokenExpiry = localStorage.getItem('zohoTokenExpiry') ? JSON.parse(localStorage.getItem('zohoTokenExpiry')) : null

let deleteToken = async () => {
    localStorage.removeItem('accessToken')
    accessToken = null
};

let deleteZohoToken = async () => {
    localStorage.removeItem('zohoAccessToken')
    localStorage.removeItem('zohoTokenExpiry')
    zohoAccessToken = null
    zohoTokenExpiry = null
};

let setToken = async (accessToken) => {
    localStorage.setItem('accessToken', JSON.stringify(accessToken))
    accessToken = localStorage.getItem('accessToken') ? JSON.parse(localStorage.getItem('accessToken')) : null
}

let setZohoToken = async (data) => {
    localStorage.setItem('zohoAccessToken', JSON.stringify(data.zohoAccessToken))
    localStorage.setItem('zohoTokenExpiry', JSON.stringify(data.zohoTokenExpiry))
    zohoAccessToken = localStorage.getItem('zohoAccessToken') ? JSON.parse(localStorage.getItem('zohoAccessToken')) : null
    zohoTokenExpiry = localStorage.getItem('zohoTokenExpiry') ? JSON.parse(localStorage.getItem('zohoTokenExpiry')) : null
}


const instance = axios.create({
    baseURL: `${process.env.REACT_APP_MANIFOLD_API_URL}`,
    //withCredentials: true ,
    headers: {
        'Content-Type': 'application/json',
    },
});

console.log("process",process.env.REACT_APP_MANIFOLD_API_URL)

// Automatically refresh token if it is about to expire
instance.interceptors.request.use(async req => {

    accessToken = localStorage.getItem('accessToken') ? JSON.parse(localStorage.getItem('accessToken')) : null
    refreshToken = localStorage.getItem('refreshToken') ? JSON.parse(localStorage.getItem('refreshToken')) : null
    let zohoTokenExpiry = localStorage.getItem('zohoTokenExpiry') ? JSON.parse(localStorage.getItem('zohoTokenExpiry')) : null

    // check if it exists

    // returns true if user does not have acess token and zoho token
    if (accessToken && zohoTokenExpiry) {

        // check if token hasn't expired
        const user = accessToken ? jwt_decode(accessToken) : null

        if (!user) {
            await deleteZohoToken();
        }
        let isUserExpired = (user.exp - dayjs().unix()) < 1 ? true : false; 
        let isZohoTokenExpired = dayjs(zohoTokenExpiry).unix() - dayjs().unix() < 1 ? true : false;
      
        if ((!isUserExpired && isUserExpired !== null) && (!isZohoTokenExpired && isZohoTokenExpired !== null)) {
            req.headers['Authorization'] = `Bearer ${accessToken}`
            return req;
        }

        if (isUserExpired) {
            localStorage.clear();
            window.location.href = "/login";
        }

        if (isZohoTokenExpired) {
            localStorage.clear();
            window.location.href = "/login";
        }
        req.headers['Authorization'] = `Bearer ${accessToken}`
        return req;
    }

    if (!accessToken && !zohoTokenExpiry) {
        return req;
    }

    if (!zohoTokenExpiry) {
        return req;
    }
    req.headers['Authorization'] = `Bearer ${accessToken}`
    return req
})




export { instance as Axios };

